<template>
  <div>
    <!-- 统计 -->
    <div class="pan">
      <div class="pan-item">
        <div class="pan-item-content">
          {{ followtaskStatistics.totalCount }}
        </div>
        <div class="pan-item-content-title">合计</div>
      </div>
      <div class="pan-item">
        <div class="pan-item-content">
          {{ followtaskStatistics.totalFinishedCount }}
        </div>
          <div class="pan-item-content-title">已完成</div>
      </div>
      <div class="pan-item">
        <div class="pan-item-content">
          {{ followtaskStatistics.totalUnFinishedCount }}
        </div>
        <div class="pan-item-content-title">未完成</div>
      </div>
      <div class="pan-item">

         <div
          class="pan-item-content "
          v-if="followtaskStatistics.totalCount > 0">
          <el-progress

             :percentage="((followtaskStatistics.totalFinishedCount * 100) /followtaskStatistics.totalCount).toFixed(0)"
            :format="format"
          ></el-progress>
        </div>
        <!-- e="
            followtaskStatistics.totalCount === 0 ||
            followtaskStatistics.totalCount === '0'
          " -->
        <div
          class="pan-item-content-title"
          v-else>
          暂无进度条
        </div>
        <div class="pan-item-content-title">进度</div>
      </div>
    </div>
    <!--  -->
    <el-button
      type="primary"
      plain
      size="small"
      @click="handleAddFollowTask"
      icon="el-icon-plus"
      style="margin-top: 20px"
      v-if="permission"
    >
      新增</el-button
    >
    <!--  -->
    <el-dialog
      title="添加跟进任务"
      :visible.sync="followTaskShow"
      append-to-body="true"
      :close-on-click-modal="false"
    >
      <el-form
        ref="taskForm"
        :rules="taskFormRules"
        :model="form"
        label-width="140px"
      >
        <el-form-item label="标题" prop="title">
          <el-input placeholder="请输入标题" v-model="form.title"> </el-input>
        </el-form-item>
        <el-form-item label="跟进内容" prop="content">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="form.content"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="起止时间" prop="validityPeriod">
          <el-date-picker
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            v-model="form.validityPeriod"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="跟进成员(待定)">
          <el-col :span="19">
          <el-input readonly v-model="form.chargeManName"></el-input>
          <el-input
            readonly
            v-model="form.chargeManId"
            style="display:none;"
          ></el-input>
        </el-col>
        <el-col :span="5">
          <el-button  @click="handleAddGroup()" type="primary">请选择</el-button>
        </el-col>
          <!-- <el-button>
            <i class="el-icon-user"></i>
            {{ form.chargeManName }}
          </el-button>
          <el-button type="primary" plain @click="handleAddChargeMan">
            <i class="el-icon-plus"></i>
          </el-button>
          <el-dialog :visible.sync="chargeMan.show" append-to-body="true">
            <avue-crud
              :option="chargeMan.option"
              :search.sync="chargeMan.search"
              :data="chargeMan.data"
              @search-change="searchChange"
            >
              <template slot-scope="scope" slot="menu">
                <el-button
                  type="text"
                  size="small"
                  @click.stop="handleSaveChargeMan(scope.row, scope.index)"
                  >选择</el-button
                >
              </template>
            </avue-crud>
          </el-dialog> -->
        </el-form-item>
        <el-form-item label="合同附件">
          <vupload :fileList.sync="form.attachList"></vupload>
        </el-form-item>
        <el-form-item style="text-align: right">
          <el-button type="primary" @click="submitAddFollowTask">
            保存
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--  -->
    <el-table :data="followTask.records" border style="margin-top: 20px">
      <el-table-column label="跟进内容">
        <template slot-scope="scope">
          <p>{{ scope.row.content }}</p>
        </template>
      </el-table-column>
      <el-table-column label="开始时间">
        <template slot-scope="scope">
          <p>{{ scope.row.followTime | showYmd }}</p>
        </template>
      </el-table-column>
      <el-table-column label="截止时间">
        <template slot-scope="scope">
          <p>{{ scope.row.validityPeriodEnd | showYmd }}</p>
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-button type="text">{{
            scope.row.followStatus == 0 ? "进行中" : "完成"
          }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100px" v-if="permission">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="follow(scope.$index, scope.row)"
            >跟进</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--  -->
    <el-pagination
      v-if="followTask.total > 10"
      background
      layout="prev, pager, next,total"
      :total="followTask.total"
      @current-change="followTaskListCurrentChange"
    >
    </el-pagination>
    <!--  -->
    <el-dialog
      title="跟进任务"
      :visible.sync="detailShow"
      append-to-body="true"
      :close-on-click-modal="false"
    >
      <el-card>
        <div slot="header">
          <span>{{ detail.content }}</span>
          <el-button style="float: right; padding: 3px 0" type="text"
            >往期</el-button
          >
        </div>
        <div class="item">
          <div>状态</div>
          <span>
            <el-button type="text">{{
              detail.followStatus == 0 ? "进行中" : "完成"
            }}</el-button>
          </span>
        </div>
        <div class="item">
          <div>合同编码</div>
          <span>{{ detail.contract.code }}</span>
        </div>
        <div class="item">
          <div>合同对象</div>
          <span>{{ getParternerName(detail.contract.partnerId) }}</span>
        </div>
        <div class="item">
          <div>合同金额</div>
          <span style="color: #409eff">{{ detail.contract.money }}</span>
        </div>
        <div class="item">
          <div>有效期</div>
          <span>{{ detail.contract.validityPeriodEnd }}</span>
        </div>
        <div class="item">
          <div>跟进时间</div>
          <span>{{ detail.validityPeriodEnd }}</span>
        </div>
        <div class="item">
          <div>跟进内容</div>
          <span>{{ detail.content }}</span>
        </div>
        <div class="feedback">
          <div>跟进反馈</div>
          <div>
            <div v-for="(item, index) in detail.feedbackList" :key="index">
              {{ item.content }}
            </div>
          </div>
        </div>
        <div class="item" v-if="feedback.inputStatus == 1">
          <div>输入反馈</div>
          <el-input
            style="width: 100%"
            type="textarea"
            v-model="feedback.input"
            maxlength="200"

            placeholder="请输入内容"
          ></el-input>
        </div>
        <hr style="margin-top: 20px" />
        <div class="button">
          <el-button
            v-if="feedback.inputStatus == 0"
            type="text"
            @click="feedbackFollowTask"
            >跟进反馈</el-button
          >
          <el-button
            v-if="feedback.inputStatus == 1"
            type="text"
            @click="feedbackSubmit"
            >提交反馈</el-button
          >
          <el-button
            v-if="feedback.inputStatus == 0 && detail.followStatus == 0"
            type="text"
            @click="finishFollowTask"
            >跟进完成</el-button
          >
        </div>
      </el-card>
    </el-dialog>
    <el-dialog
      title="请选择人员"
      :visible.sync="dialogUserEditBoxVisible"
      fullscreen
      append-to-body
      width="80%"
      :close-on-click-modal="false"
    >
      <user-edit-box
        v-if="dialogUserEditBoxVisible"
        :remainUserListInside.sync="remainUserList"
        :userNum='1'
        @closeAction="handleCloseAction"
        @submitAction="handleSubmitAction"
        @editAction="handleEditAction"
        :selectType.sync="selectUserType"
        :handleAction.sync="handleAction"
        :projectId.sync="contract.projectId"
      />
    </el-dialog>
  </div>
</template>

<script>
import {
  getFollowTaskDetail,
  saveFollowTask,
  getFollowTaskList,
  finishFollowTask,
  saveFollowFeedback,
  followtaskStatistics,
  projectUserList,
} from "@/api/crmedical/contract/execution";

import { formatTime } from "@/util/apputil";
import { vString } from "@/util/validate";
import vupload from "@/views/components/v-upload";
import userEditBox from '@/components/user-edit-box/user-edit-box';
// 合同跟进模块
export default {
  components: {
    vupload,userEditBox
  },
  filters: {
    showYmd(val) {
      // YYYY-MM-DD HH:mm:ss ==> YYYY-MM-DD
      if (val) {
        return val.slice(0, 10);
      } else {
        return "";
      }
    },
  },
  computed: {
    // 合同对象 key value 切换
    getParternerName() {
      return function (partnerId) {
        for (let i = 0; i < this.partnerList.length; i++) {
          if (this.partnerList[i].id == partnerId) {
            return this.partnerList[i].name;
          }
        }
      };
    },
  },
  props: ["id", "contract", "partnerList",'permission'],
  data() {
    return {
      remainUserList: [],
      handleAction: '',//1是新增模式,2是编辑模式。
      selectUserType: '1',
      checkPcUserNames:'',
      dialogUserEditBoxVisible:false,//选择人
      followTaskShow: false,
      // 列表
      followTask: {
        records: [],
        current: 1,
        total: 0,
      },
      // 统计
      followtaskStatistics: {
        totalCount: "",
        totalFinishedCount: "",
        totalUnFinishedCount: "",
      },
      // 表单
      form: {
        contractId: null,
        validityPeriod: "",
        content: "",
        chargeManId: "",
        chargeManName: "",
        title: "",
        attachList: [],
      },
      // 表单校验
      taskFormRules: {
        content: [
          {
            required: true,
            validator: vString("跟进内容", 1, 400),
            trigger: "blur",
          },
        ],
        title: [
          {
            required: true,
            validator: vString("跟进标题", 1, 50),
            trigger: "blur",
          },
        ],
        validityPeriod: [
          { required: true, message: "请选择时间区间", trigger: "blur" },
        ],
      },
      // 责任人 Avue-crud
      chargeMan: {
        show: false,
        data: [],
        option: {
          searchMenuSpan: 8,
          addBtn: false,
          editBtn: false,
          delBtn: false,
          refreshBtn: false,
          columnBtn: false,
          column: [
            {
              label: "姓名",
              prop: "realName",
              searchRules: [
                {
                  required: true,
                  message: "请输入姓名",
                  trigger: "blur",
                },
              ],
            },
          ],
        },
      },
      // 详情与反馈相关
      detailShow: false,
      detail: {
        followStatus: 0,
        contract: {},
      },
      feedback: {
        input: "",
        inputStatus: 0,
      },
    };
  },
  created() {
    this.loadFollowTaskList();
    this.loadFollowTaskStatistics();
  },
  methods: {
    // handleEditAction(val){
    //   this.form.chargeManName = val.nameListString;
    //   this.form.chargeManId = val.idListString;
    //   this.dialogUserEditBoxVisible = false;
    // },
    handleSubmitAction(val) {
      this.form.chargeManName = val.nameListString;
      this.form.chargeManId = val.idListString;
      console.log(this.form)
      this.dialogUserEditBoxVisible = false;
    },
    handleCloseAction(){
     this.dialogUserEditBoxVisible = false
    },
    handleAddGroup() {
      this.handleAction = '1'
      // console.log(this.handleAction)
      this.dialogUserEditBoxVisible = true;
    },
    // 分页
    followTaskListCurrentChange(val) {
      this.followTask.current = val;
      this.loadFollowTaskList();
    },
    // projectUserList
    loadProjectUserList() {
      const params = {
        projectId: this.contract.projectId,
      };
      projectUserList(params).then((res) => {
        this.chargeMan.data = res.data;
      });
    },
    // 负责人
    handleAddChargeMan() {
      this.loadProjectUserList();
      this.chargeMan.show = true;
    },
    // 负责人选择
    handleSaveChargeMan(row) {
      this.form.chargeManId = row.id;
      this.form.chargeManName = row.realName;
      this.chargeMan.show = false;
    },
    // 获取跟进列表
    loadFollowTaskList() {
      getFollowTaskList({
        contractId: this.id,
        current: this.followTask.current,
      }).then((res) => {
        this.followTask = res.data;
      });
    },
    // 获取跟进统计
    loadFollowTaskStatistics() {
      followtaskStatistics({ id: this.id }).then((res) => {
        this.followtaskStatistics = res.data;
      });
    },
    // 显示新增任务弹窗
    handleAddFollowTask() {
      this.followTaskShow = true;
    },
    // 任务保存
    submitAddFollowTask() {
      this.$refs.taskForm.validate((validateResult) => {
        if (!validateResult) {
          return false;
        } else {
          this.form.contractId = this.id;
          this.form.validityPeriodEnd = formatTime(this.form.validityPeriod[1]);
          this.form.followTime = formatTime(this.form.validityPeriod[0]);
          saveFollowTask(this.form).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: res.msg,
              });
            }
            // 刷新状态
            this.loadFollowTaskList();
            this.loadFollowTaskStatistics();
            this.$emit("loadRecordList");
            this.followTaskShow = false;
            this.form.validityPeriod = "";
            this.form.content = "";
            this.form.chargeManId = "";
            this.form.chargeManName = "";
            this.form.title = "";
            this.form.attachList = [];
          });
        }
      });
    },
    // 获取任务详情,显示详情弹窗
    follow(index, row) {
      getFollowTaskDetail({ id: row.id }).then((res) => {
        this.detail = res.data;
        this.detailShow = true;
      });
    },
    // 任务完成
    finishFollowTask() {
      const postData = {
        id: this.detail.id,
        followStatus: 1,
      };
      finishFollowTask(postData).then((res) => {
        this.$message({
          type: "success",
          message: res.msg,
        });
        this.detailShow = false;
        this.clearStatus();
        this.loadFollowTaskList();
        this.loadFollowTaskStatistics();
        this.$emit("loadRecordList");
      });
    },
    // 显示反馈输入
    feedbackFollowTask() {
      this.feedback.inputStatus = 1;
    },
    //  提交反馈
    feedbackSubmit() {
      const postData = {
        content: this.feedback.input,
        followTaskId: this.detail.id,
        attachList: [],
      };
      saveFollowFeedback(postData).then((res) => {
        if (res.success) {
          this.clearStatus();
        }
        this.detailShow = false;
        this.$emit("loadRecordList");
      });
    },
    // 移除状态
    clearStatus() {
      this.feedback = {
        input: "",
        inputStatus: 0,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.gutter {
  height: 40px;
}
.form-item-width {
  width: 70%;
}
::v-deep .el-progress {
    width: 128px;
    // display: grid;
    // grid-template-columns: 2fr 1fr;
    // align-items: center;
    display: flex;
    align-items: center;
    height: 26.67px;
    position: relative;
}
// ::v-deep .el-progress {
//   display: flex;
// }
::v-deep .el-progress__text {
  font-size: 16px;
  font-family: 'Segoe UI';
  font-weight: 400;
  // margin-left: 0;
  color: #303133;


    width: 100px;
    position: absolute;
    // left: 55px;
    left: 50%;
    transform: translateX(25%);

}
.pan {
  // display: flex;
  // justify-content: space-around;
  display: grid;
  grid-template-columns: repeat(4,1fr);
  background-color: #F2F6FC;
  border-radius: 4px;
  // padding: 10px;
  .pan-item {
    height: 88px;
    padding: 20px 0;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    text-align: center;
    box-sizing: border-box;
    justify-content: center;
    .pan-item-content {
      width: 100%;
      // line-height: 40px;
      font-size: 18px;
      font-family:' Microsoft YaHei UI';
      font-weight: bold;
      color: #303133;
      display: flex;
      justify-content: center;
    }
    .pan-item-content-title{
      width: 100%;
      font-size: 14px;
      font-family: 'Microsoft YaHei UI';
      font-weight: 400;
      // line-height: 40px;
      color: #909399;
    }
    .pan-process {
      min-width: 150px;
      height: 40px;
      // display: flex;
      // align-items: center;
    }
  }
}
.item {
  display: flex;
  justify-content: flex-start;
  height: 60px;
  line-height: 60px;
  div {
    width: 100px;
  }
}
.button {
  display: flex;
  justify-content: space-around;
}
.feedback {
  display: flex;
  justify-content: flex-start;
  div:first-child {
    width: 100px;
  }
  div {
    line-height: 60px;
  }
}
</style>
